import type { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from '@/components/Checkbox';

// The header ticks the rows on screen, not the whole data set: rows hidden by a filter or a
// search must not ride along into a bulk action.
export function createSelectColumn<TData>(): ColumnDef<TData> {
  return {
    id: 'select-col',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected()}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      />
    ),
    cell: ({ row }) => (
      <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
        <Checkbox
          checked={row.getIsSelected()}
          disabled={!row.getCanSelect()}
          onCheckedChange={row.getToggleSelectedHandler()}
        />
      </div>
    ),
    enableSorting: false,
    size: 50,
  };
}
